
import { defineComponent, onMounted, reactive, ref } from "vue";
import { useRoute } from "vue-router";
import { component, message } from "@ajia/vue-next-ppt-component";
import {
    getSlideDataById,
    getUserPptById,
    updatePpt,
    analyzePpt,
} from "@/api/index_test";
import { getUploadFileUrl, getTestSlideData } from "@/api";

export default defineComponent({
    name: "home",
    components: {
        pptEditor: component as any,
    },
    setup() {
        const route = useRoute();
        const slideData = ref({});
        const playing = ref(false);
        const saving = ref(false);

        let title = route.query.name as string;
        if (title) {
            document.title = title;
        }

        const getSlideData = async () => {
            let url = location.href;
            if (
                url.indexOf("192.") === -1 &&
                url.indexOf("test-ppt.ajia.cn") === -1
            ) {
                let id = url.split("id=")[1];
                const { data } = await getSlideDataById({ id: id });
                slideData.value = data;
            }
        };

        const saveSlideData = async ({ data }: any) => {
            const { pptId } = slideData.value as any;
            data.pptId = pptId;
            return await updatePpt(data);
        };

        const handleSave = (e: { [key: string]: string }) => {
            saving.value = true;
            saveSlideData(e)
                .then((d) => {
                    message.success("保存成功");
                })
                .catch((err) => {
                    console.log(err);
                    message.error("保存失败");
                })
                .finally(() => {
                    saving.value = false;
                });
        };

        const uploading = ref(false);
        const loading = reactive({
            spinning: false,
            text: "加载中",
        });
        const uploadedData = ref<any>(null);
        const uploadResource = async (
            sourceType: string,
            file: any,
            pptId: string
        ) => {
            const { data } = await getUploadFileUrl({
                file,
                pptId,
                sourceType,
            });
            return data;
        };
        const handleUpload = (e: any) => {
            const { type, file } = e;
            uploading.value = true;
            loading.spinning = true;
            const pptId = route.query.id as string;
            uploadResource(type, file, pptId)
                .then((result: any) => {
                    if (result) {
                        if (type === "ppt") {
                            uploading.value = true;
                            analyzePpt({ pptUrl: result.url })
                                .then((res: any) => {
                                    const { data } = res;
                                    uploadedData.value = { type, data };
                                })
                                .finally(() => {
                                    uploading.value = false;
                                    loading.spinning = false;
                                });
                        } else {
                            const { oriName, url } = result;
                            uploadedData.value = { type, url };
                            loading.spinning = false;
                        }
                    }
                    return false;
                })
                .catch((err) => {
                    console.log(err);
                    loading.spinning = false;
                })
                .finally(() => {
                    uploading.value = false;
                });
        };
        onMounted(() => {
            getSlideData();
        });
        return {
            slideData,
            playing,
            saving,
            handleSave,
            loading,
            uploading,
            uploadedData,
            handleUpload,
        };
    },
});
